import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppStateService {
  private key = 'appStateValue';

  // Save value to localStorage
  setValue(value: any): void {
    try {
      const jsonValue = JSON.stringify(value);
      localStorage.setItem(this.key, jsonValue);
    } catch (error) {
      console.error('Error storing value:', error, value);
    }
  }

  // Get value from localStorage
  getValue(): any {
    try {
      const storedValue = localStorage.getItem(this.key);
      return storedValue ? JSON.parse(storedValue) : null;
    } catch (error) {
      console.error('Error retrieving value:', error);
      return null;
    }
  }

  // Clear the stored value
  clearValue(): void {
    localStorage.removeItem(this.key);
  }
}